import { Box, InfoIcon, Tooltip } from '@adamdotai/design-system'
import { useTranslations } from 'next-intl'

export const FeedbackTooltip = () => {
    const t = useTranslations()
    return (
        <Tooltip
            label={t(
                'meetingroom.ai-generated-content-may-be-incorrect-or-misleading',
            )}
            placement="top-end"
        >
            <Box ps="1">
                <InfoIcon
                    data-testid="ai-summary-feedback-info-icon"
                    color="secondary.1300"
                    size="sm"
                />
            </Box>
        </Tooltip>
    )
}
